import { IHouseHoldAgeDetails, IHouseHoldQuotation } from "../../../../modules/houseHold/utils/interfaces";
import { RootState } from "../../../store";
import { createSlice } from "@reduxjs/toolkit";

interface IDetails {
  AgeDetails: IHouseHoldAgeDetails;
  leadDetails: IHouseHoldQuotation;
  quoteID: string | undefined;
  dob: string;
}

const initialState: IDetails = {
  AgeDetails: {},
  dob: "",
  leadDetails: {},
  quoteID: undefined
};

// eslint-disable-next-line import/no-unused-modules
export const userDetails = createSlice({
  name: "user",
  initialState,
  reducers: {
    AddDetails: (state, payload) => {
      state.AgeDetails = payload.payload;
    },
    AddDOB: (state, payload) => {
      state.dob = payload.payload;
    },
    AddLeadDetails: (state, payload) => {
      state.leadDetails = payload.payload;
    },
    AddQuoteId: (state, payload) => {
      state.quoteID = payload.payload;
    },

    // eslint-disable-next-line no-param-reassign, no-unused-vars, @typescript-eslint/no-unused-vars
    ResetUser: state => (state = initialState)
  }
});

// Action creators are generated for each case reducer function
export const { AddDetails, AddLeadDetails, AddQuoteId, ResetUser, AddDOB } = userDetails.actions;

export default userDetails.reducer;

export const getUserDetails = (state: RootState): IDetails => state.user;
export const getLeadDetails = (state: RootState): IHouseHoldQuotation => state.user.leadDetails;
